/* -- This file does not have a hard server side route, it is routed client side
     inside of app/page/display/display.js. It requires to a model and an init
     function in order to work correctly. You will see these are exported at the
     bottom of this page. Some of this code, especially the sidebar height portion
     has been ripped from pinboard.js.  Since it is used in more than these two
     spots it is a project for another day to make them common functions.
--*/

import {
  config,
} from '../../../shared/shared';

import i18n from '../../../shared/i18n/i18n';

import Sticky from '../../../shared/util/sticky';

import Api from '../../../shared/api';

const Curriculum = ((function () {
  const localizedResource = i18n.resource;
  const levelsToGrades = localizedResource('resource.packs.levels.to.grades');
  const level = 2;

  const gradeRanges = localizedResource('my.content.grade.ranges');
  const currStandardGrades = localizedResource('curriculum.standard.grades');

  const model = {

    // jquery selectors
    $standards: null,

    config,

    /* -- Function binding --*/

    afterCurriculumRender,
    init,
    getDifferentiatedPacksHtml,
    backToPinboard,
    determineDefaultLevel,
    checkFindPackState,
    getAttributeByGuid,
    loadFilterValues,
    loadStandardsFromUrl,
    loadStandardsFromFilter,
    loadStandardsFromBrowse,
    packId: ko.observable(),
    view: ko.observable('standards'),

    // Standards

    gradeLevels: ko.observableArray(),
    standards: ko.observableArray(),
    regions: ko.observable(),
    info: ko.observable(),
    subjects: ko.observable(),

    /*--
    We need to keep state for both sets of filters despite them having the same
    fields.  The first set relates to the first set of filters, while the second
    set is for the bottom set of filters that handles posting to the browse page.
    --*/

    // Curriculum Standards Filters (1)
    subjectOptions: ko.observable(), // List of subject options
    subjectSelection: ko.observable(), // Currently selected subject
    publicationOptions: ko.observable(), // List of publication options (dependent on subject selection)
    publicationSelection: ko.observable(), // Currently selected publication option
    publicationSelectionName: ko.observable(), // Currently selected publication name
    publicationSelectionMessage: ko.observable(null), //This is whether to show a message or not about the state see PAC-2073 for details
    gradeOptions: ko.observable(), // List of possible grades can be a range (this depends on the pack)
    gradeSelection: ko.observable(''), // Currently selected grade or grade range
    gradeSelectionName: ko.observable(), // Name of the currently selected grade name
    //

    // Curriculum Standards Filters (2 AKA Browse)
    subjectOptionsBrowse: ko.observable(), // List of subject options
    subjectSelectionBrowse: ko.observable(), // Currently selected browse option
    publicationOptionsBrowse: ko.observable(), // List of all publications (dependent on subject selection)
    publicationSelectionBrowse: ko.observable(), // Selected publication or standard
    gradeOptionsBrowse: ko.observable(), // List of possible grades only single grades
    gradeSelectionBrowse: ko.observable(), // currently selected grade
    //
    isLoading: ko.observable(true), // Are we currently loading data
    isTimeout: ko.observable(false),

  };

  // SUBSCRIPTIONS
  /*--
    When the first subject selection changes reload the standards/publications
  --*/

  model.subjectSelection.subscribe((v) => {
    Api.CurriculumStandards.fetchCurriculumStandardsPublicationsBySubject(v)
      .then((data) => {
        model.publicationOptions(data.publications);
        model.publicationSelection(data.defaultPublicationGuid);
      });
  });

  /*--
    When the second subject selection changes reload the standards/publications
    for the browse filters
  --*/

  model.subjectSelectionBrowse.subscribe((v) => {
    Api.CurriculumStandards.fetchCurriculumStandardsPublicationsBySubject(v)
      .then((data) => {
        model.publicationOptionsBrowse(data.publications);
        model.publicationSelectionBrowse(data.defaultPublicationGuid);
        model.checkFindPackState();
      });
  });

  /*--
    When the grade selection changes check if we can now submit the form
  --*/

  model.gradeSelectionBrowse.subscribe(() => {
    model.checkFindPackState();
  });

  /*--
    When the grade selection changes in the browse filters check if we can now
    submit the form
  --*/

  model.publicationSelectionBrowse.subscribe(() => {
    model.checkFindPackState();
  });

  function init(rawData, packId) {
    // TODO: come up with a better fix for this.

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);

    // This is all yanked from pinboard.js

    /*--
      dataCopy is data we have already that was loaded from the pinboard code. Just
      being extra cautious by not mutating the original.
    --*/

    const dataCopy = Object.clone(rawData, true);
    const gradeRangeCopy = dataCopy.pack.gradeIds && gradeRanges.find(grade => dataCopy.pack.gradeIds.find(id => grade.value === id));

    dataCopy.pack.gradeRange = gradeRangeCopy && gradeRangeCopy.fullLabel;
    dataCopy.pack.gradeFullLabel = dataCopy.pack.gradeRange;

    // TODO: rewrite as pure function so this makes more sense

    determineDefaultLevel(dataCopy.pack.gradeIds);

    const differentiatedPacksCopy = Object.values(Object.map(dataCopy.pack.differentiatedPackIdsForGradeRanges, (key, value) => ({
      grade: gradeRanges.find(grade => key == grade.value) && gradeRanges.find(grade => key == grade.value).shortLabel,
      packId: value,
    })));

    dataCopy.pack.differentiatedPacksHtml = getDifferentiatedPacksHtml(differentiatedPacksCopy);
    dataCopy.pack.differentiatedPacksCount = Object.entries(differentiatedPacksCopy).length;
    // End of yank

    model.info(dataCopy);

    /*--
    Get all the options for the filters as well as the default values for the
    filters.
    --*/

    model.packId(packId);
    loadFilterValues(model.packId());
  }

  /*--
    loadFilterValues
    Params:
    packId: int
    ---------------------
    Comments: Used to populate both sets of filters.
  --*/

  function loadFilterValues(packId) {
    Api.CurriculumStandards.fetchPublicationsSubjectsAndGradeLevels(packId, '').then((data) => {

      /*--
        We load all of the options for the first filter and the second filter (browse) at the same timestamp
        the amount of extra data is nominal and it felt better than making another AJAX call.
      --*/

      // PAC-2073 Whether to show the default California message or not.

      model.publicationSelectionMessage((typeof data.publicationMessage == 'undefined') ? null : data.publicationMessage);

      // Filter options

      model.subjectOptions(_.sortBy(data.subjects, ['order']));
      model.publicationOptions(data.publications);
      const currGrades = [];
      data.gradeLevels.forEach((gradeLevel) => {
            const _grade = gradeLevel.guid ? currStandardGrades.find(currGrade => currGrade.guid == decodeURIComponent(gradeLevel.guid)) : {name : `${gradeLevel.name}`, guid : ``, sequence : 0};
            currGrades.push(_grade);
          });
      model.gradeOptions(_.sortBy(currGrades, ['sequence']));

      // Browse filter options

      model.subjectOptionsBrowse(_.sortBy(data.subjects, ['order']));

      const currGradesBrowse = [];
      data.gradeLevelsForBrowse.forEach((gradeLevel) => {
            const _grade = gradeLevel.guid ? currStandardGrades.find(currGrade => currGrade.guid == decodeURIComponent(gradeLevel.guid)) : {name : `${gradeLevel.name}`, guid : ``, sequence : 0};
            currGradesBrowse.push(_grade);
         });
      model.gradeOptionsBrowse(_.sortBy(currGradesBrowse, ['sequence']));
      model.publicationOptionsBrowse(data.publications);

      // Filter selections

      model.publicationSelection(data.defaultPublicationGuid);
      model.gradeSelection(data.defaultGradeRangeGuid);
      model.subjectSelection(data.defaultSubjectGuid);

      // Browse filter selections

      model.publicationSelectionBrowse(data.defaultPublicationGuid);
      model.gradeSelectionBrowse(data.defaultGradeRangeGuid);
      model.subjectSelectionBrowse(data.defaultSubjectGuid);

      // Display names for dropdown options.

      model.gradeSelectionName(model.getAttributeByGuid(model.gradeOptions(), model.gradeSelection()));
      model.publicationSelectionName(model.getAttributeByGuid(model.publicationOptions(), model.publicationSelection(), 'displayName'));

      /* -- Normalize the parameters, just in case, we don't want to accidentally
      send undefined just an empty string. --*/

      const publication = (typeof model.publicationSelection() !== 'undefined') ? model.publicationSelection() : '';
      const grade = (typeof model.gradeSelection() !== 'undefined') ? model.gradeSelection() : '';
      const subject = (typeof model.subjectSelection() !== 'undefined') ? model.subjectSelection() : '';

      // Go get the curriculum standards

      loadStandardsFromUrl(model.packId(), publication, grade, subject);
    });
  }

  /*--
    loadStandardFromlUrl
    Params:
    packId: int,
    publicationGuid: string,
    gradeGuid: string,
    subjectGuid: string,
    ---------------------
    Comments: Run when there are adequate query parameter values.
  --*/

  function loadStandardsFromUrl(packId, publication, grade, subject) {
    Api.CurriculumStandards.fetchCurriculumStandards(model.packId(), publication, grade, subject).then((currStandards) => {
      model.isLoading(false);
      model.isTimeout(false);

      model.standards(currStandards[0]);
      model.subjects(currStandards[0].subjects);
    }).catch((e) => {
      model.isLoading(false);
      model.isTimeout(true);
    });
  }

  /*--
    loadStandardsFromFilter
    Params:
    packId: integer,
    publicationGuid: string,
    gradeGuid: string,
    subjectGuid: int,
    -----------------------
    Comments: This is run when the 'View Results' button is clicked in the right
    hand rail.
  --*/

  function loadStandardsFromFilter() {
    // model.$loading.show();
    model.isLoading(true);

    const publication = (model.publicationSelection()) ? model.publicationSelection() : '';
    const grade = (model.gradeSelection()) ? model.gradeSelection() : '';
    const subject = (model.subjectSelection()) ? model.subjectSelection() : '';
    model.publicationSelectionMessage(null); //Remove the message as now they are conciously chosing a location.

    model.standards([]);
    model.subjects([]);
    Api.CurriculumStandards.fetchCurriculumStandards(model.packId(), publication, grade, subject).then((currStandards) => {
      //Remove the message as now they are conciously chosing a location.

      model.isLoading(false);
      model.gradeSelectionName(model.getAttributeByGuid(model.gradeOptions(), model.gradeSelection()));
      model.publicationSelectionName(model.getAttributeByGuid(model.publicationOptions(), model.publicationSelection(), 'displayName'));
      model.standards(currStandards[0]);
      model.subjects(currStandards[0].subjects);
    }).catch(() => {
      model.isLoading(false)
      model.isTimeout(true);
    });
  }

  /*--
    loadStandardsFromFilter
    -----------------------
    Comments: This creates a url to the curriculum browse page with query
    paramaters populated.  This is activated from the View Results buttons
    on the second set of filters on a packs standards page.
  --*/

  function loadStandardsFromBrowse() {
    const subject = $('body').data('subjectAreaPath');
    const subjectGuid = model.subjectSelectionBrowse();
    const standardGuid = model.publicationSelectionBrowse();
    const standardGrades = model.gradeSelectionBrowse();

    window.location = `/${subject}/curriculumstandards/browse?subject=${subjectGuid}&publication=${standardGuid}&grade=${standardGrades}`;
  }

  /*--
    getAttributeByGuid
    Params:
    publications: array/collection
    guid: string
    attribute: string (optional) -- which attribute to return, if different than 'name' (e.g. 'displayName')
    ----------------------
    Comments: This returns the grade or publication name when passed a
    collection of grades and a grade guid.
  --*/

  function getAttributeByGuid(collection, guid, attribute = 'name') {
    const item = collection.find(itm => itm.guid === guid);

    return item[attribute];
  }

  function backToPinboard() {
    window.location = '#pinboard';
  }

  function determineDefaultLevel(grades) {
    const matchings = Object.map(levelsToGrades, (key, value) => value.intersect(grades).length);
    const level = parseInt(Object.max(matchings), 10);
  }

  function getDifferentiatedPacksHtml(list) {
    if (list && Array.isArray(list) && list.length) {
      const comma = ', ';
      const crossLinksOr = i18n.string('packs.header.differentiated.crosslinks.or');
      const gradesLabel = i18n.string('packs.grades');
      const htmlList = list.map((pack) => {
        const displayLabel = (pack.grade.toLowerCase() === 'foundation') ? pack.grade : `${gradesLabel} ${pack.grade}`; // PAC-1032

        return `<a href="${pack.packId}">${displayLabel}</a>`;
      });


      if (list.length < 3) {
        return htmlList.join(` ${crossLinksOr} `);
      }

      htmlList[htmlList.length - 1] = `${crossLinksOr} ${htmlList[htmlList.length - 1]}`;

      return htmlList.join(comma);
    }

    return '';
  }

  /*--
    afterCurriculiumRender
    Params:
    ----------------------
    Comments: This is called once the template associated with this file
    renders. The template is called from within
    /app/page/display/includes/curriculumStandards.jsp
  --*/

  function afterCurriculumRender() {
    /*--
    We have to populate these after render, as they aren't available when they
    are originally defined inside of the model.
    --*/

    model.$postLoad = $('.post-load');
    model.$preload = $('.pre-load');
    model.$standards = $('#curriculum-standards');
    model.$findPacksButton = $('#find-packs');
    // model.$loading = $('.curriculum-standards .loading');


    /*
    PAC-2380
     */
    // setTimeout(() => {
    //   Sticky.init('.pack-display .pack-display-pinnable', 140);
    // }, 300);
  }

  // Checks to see if enough items are seleced to disable the 'View Results' button in the browse filter selection.

  function checkFindPackState() {
    if (typeof model.publicationSelectionBrowse() !== 'undefined' && typeof model.gradeSelectionBrowse() !== 'undefined' && typeof model.subjectSelectionBrowse() !== 'undefined') {
      model.$findPacksButton.attr('disabled', false);
    }
    else {
      model.$findPacksButton.attr('disabled', true);
    }
  }

  return {
    init,
    model,
  };
}()));

export default Curriculum;



// WEBPACK FOOTER //
// ./javascript/app/page/display/includes/curriculumStandards.js